"use strict";

(function () {

    $.widget('khis.nosologicGroup', {
        options: {
            //Translations
            nosologicGroupHeaderTranslate: "Unidade Nosológica Principal",
            nosologicGroupSecudaryHeaderTranslate: "Unidade Nosológica Secundária",
            principalDiagnosisRranslate: 'Diagnostico Principal',
            diagnosisDescriptionTranslate: 'Descrição do Diagnóstico',
            addNewNosologicGroup: "Adicionar nova Unidade Nosológica",
            removeNosologicGroup: "Remover Unidade Nosológica",
            addSecundaryDiagnosisTranslate: 'Diagnóstico Associado',
            surgicalActsTranslate: 'Actos Cirurgícos',
            codeTranslate: "Código",
            descriptionTranslate: "Descrição",
            kTranslate: "K",
            valorizationTranslate: "valorização",
            lateralityTranslate: "Lateralidade",
            vidTranslate: "VID",
            extTranslate: "EXT",
            incTranslate: "INC",
            tratTranslate: "TRAT",
            vidTitleTranslate: "Video Conferencia",
            extTitleTranslate: "Extração",
            incTitleTranslate: "Mesma Incisão",
            tratTitleTranslate: "Tratamento não cirurgico",
            percentageTranslate:"%",
            surgicalActDescriptionTranslate: "Descrição acto médico",
            lateralizationList: [],
            readOnly: false,
            surgicalActCodifiedMandatory:false
        },
        lateralizationList: [],
        readOnly: false,
        nosologicGroupId: null,
        index: 0,
        mainDiagnose: {},
        surgicalActNextId: 0,
        title: '',
        header: null,
        loading: null,
        container: null,
        mainDiagnoseElement: null,
        secundaryDiagnoseElement: null,
        diagnosisDescription: null,
        medicalActSearchElem: null,
        medicalActsMandatory: null,
        medicalActsTableElem: null,
        medicalActDescriptionElem: null,
        _create: function () {
            this.nosologicGroupId = this.element.data('id');
            this.index = this.element.data('index');
            this.mainDiagnose = {};
            this.surgicalActNextId = 0;
            this.lateralizationList = this.options.lateralizationList;
            this.readOnly = this.options.readOnly;
            this.surgical_record = this.options.surgical_record;
            this.surgical_screen_type = this.options.surgical_screen_type;

            if (this.index > 0) {
                debug.log('INSIDE COMPONENT ', this.options.nosologicGroupSecudaryHeaderTranslate);
                this.title = this.options.nosologicGroupSecudaryHeaderTranslate + ' ' + this.index;
            } else {
                this.title = this.options.nosologicGroupHeaderTranslate;
            }

            this._drawComponent();
            this._drawHeader();
            this._drawMainDiagnose();
            this._drawDiagnosisDescription();
            this._drawSecundaryDiagnose();
            this._drawMedicalActs();

            this.element.append(this.header);
            this.element.append(this.loading);
            this.component.append(this.mainDiagnoseElement);
            this.component.append(this.secundaryDiagnoseElement);
            this.component.append(this.diagnosisDescription);
            if (!this.readOnly) {
                this.component.append(this.medicalActSearchElem);
            }
            this.component.append(this.medicalActsMandatory);
            this.component.append(this.medicalActsTableElem);
            this.component.append(this.medicalActDescriptionElem);
            this.element.append(this.component);

            if (this.nosologicGroupId) {
                // Load state
                this.loadState();
            } else {
                this.loading.hide();
                this.component.show();
            }
        },

        _init: function () {

            const _self = this;

            this._on({
                'click span.add_nosologic_group': function (evt) {
                    _self.element.trigger('nosologicGroupAdd', {id: _self.nosologicGroupId, index: _self.index});
                }
            });

            this._on({
                'click span.remove_nosologic_group': function (evt) {

                    this.element.trigger('nosologicGroupRemoved', {id: _self.nosologicGroupId, index: _self.index});

                    $.Widget.prototype.destroy.apply(_self, arguments);

                    _self.element.remove();
                }
            });

            this.initializeAutoSearch();

            this._on({
                'click button[role=search_diagnosis]': function (evt) {
                    _self.searchDiagnosisModal(evt.target);
                }
            });

            this._on({
                'click button[role=clear_diagnosis]': function (evt) {
                    this.clearPrincipalDiagnosis();
                }
            });

            this._on({
                'click span.add_line_diagnosis.txt_link': function (evt) {
                    _self.searchMultipleDiagnosisModal();
                }
            });

            this._on({
                'click span.ui-icon.ui-icon-plus.add_line_diagnosis_plus': function (evt) {
                    _self.searchMultipleDiagnosisModal();
                }
            });

            this._on({
                'click span.remove_secundary_diagnosis_line': function (evt) {
                    _self.removeLinesSecundaryDiagnosisTable(evt.target);

                    if (_self.secundaryDiagnoseElement.find('tr').length == 0) {
                        _self.secundaryDiagnoseElement.css('margin-top', '0px');
                    }
                }
            });

            this._on({
                'click button.square_btn.search_square_btn.search_surgical_act': function (evt) {
                    _self.searchSurgicalActModal();
                }
            });

            this._on({
                'click span.ui-icon.ui-icon-trash.remove_surgical_act': function (evt) {
                    _self.removeSurgicalActLine(evt.target);
                }
            });
        },
        _drawComponent: function () {
            this.element.css('padding-bottom', '15px');
            this.component = $('<div></div>').css('display', 'none');
            this.loading = $('<div role="loading" style="margin: 0 auto;"><img style="margin: auto" src="/assets/progress_bar.gif" alt="Loading" align="middle"></div>');
        },
        _drawHeader: function () {
            debug.log('_drawHeader', this.options.nosologicGroupSecudaryHeaderTranslate);
            var top_line = '<div style="padding: 4px; border-bottom: 1px solid #a9d9e0; margin-bottom: 8px;">' +
                '<div class="float_left">' +
                '<span style="font-weight: bold;">' + (this.index > 0 ? (this.options.nosologicGroupSecudaryHeaderTranslate + ' - ' + this.index) : this.options.nosologicGroupHeaderTranslate) + '</span>' +
                '</div>';

            if (this.readOnly) {
                top_line += '<div class="spacer"></div>';
            } else {
                top_line += '<div class="float_right"><span class="add_nosologic_group txt_link" style="margin-right: 4px;">' + this.options.addNewNosologicGroup + '</span>';

                var removeNosologicGroup = '';
                if (this.index > 0) {
                    removeNosologicGroup = '<span class="remove_nosologic_group txt_link" style="margin-right: 4px;">' + this.options.removeNosologicGroup + '</span>';
                }

                top_line += removeNosologicGroup;
                top_line += '</div><div class="spacer"></div>';
            }

            this.header = $(top_line);
        },
        _drawMainDiagnose: function () {
            if (this.readOnly) {
                var mainDiagnosis = '<div class="detail_elem" style="min-width: 245px;">' +
                    '<div class="detail_label" style="width: 100%;">' + this.options.principalDiagnosisRranslate + '</div>' +
                    '<div class="detail_value" style="margin-top: 8px;" role="principal_diagnosis"></div>' +
                    '</div>';
            } else {
                var mainDiagnosis = '<div class="form_elem" style="margin-bottom: 0px;">' +
                    '<div>' +
                    '<div class="form_label">' +
                    '<label for="principal_diagnosis" class="form_label">' + this.options.principalDiagnosisRranslate + '</label>' +
                    '</div>' +
                    '<div class="float_left">' +
                    '<input type="text" value="" style=" float: left; min-width:240px; width: 400px;" class="input_grad" role="principal_diagnosis" name="principal_diagnosis" placeholder="' + this.options.principalDiagnosisRranslate + '">' +
                    '<div class="float_left" style="margin-left: 4px;">' +
                    '<button type="button" role="search_diagnosis" class="float_left square_btn search_square_btn" tabindex="-1"></button>' +
                    '<button type="button" role="clear_diagnosis" class="float_left square_btn close_square_btn_red" tabindex="-1" style="display: none;"></button>' +
                    '<span class="float_left ui-icon ui-icon-plus add_line_diagnosis_plus " style="margin-top: 7px; cursor: pointer;"></span>' +
                    '<span class="float_left add_line_diagnosis txt_link" style="margin-left: 4px; line-height: 30px;">' + this.options.addSecundaryDiagnosisTranslate + '</span>' +
                    '</div>' +
                    '</div>' +
                    '<div class="spacer"></div>' +
                    '</div>' +
                    '</div>';
            }

            mainDiagnosis += '<div class="spacer"></div>';

            this.mainDiagnoseElement = $(mainDiagnosis);
        },

        _drawDiagnosisDescription: function () {
            var diagnosis_description = '';
            if (this.readOnly) {
                diagnosis_description = '<div class="detail_elem" style="min-width: 245px; padding-bottom: 0px; margin-bottom: 0px; margin-top: 8px;">' +
                    '<div class="detail_label" style="width: 100%;">' + GlobalTranslations['appLabel2449'] + '</div>' +
                    '<div class="form_elem " style="margin-top: 8px;" role="diagnosis_description"></div>' +
                    '</div>';

            } else {
                diagnosis_description = '<div class="form_elem" style="margin-top: 8px;">' +
                    '<div class="form_label">' +
                    '<label for="diagnosis_description" class="form_label ">' + GlobalTranslations['appLabel2449'] + '</label>' +
                    '</div>' +
                    '<div class="form_value">' +
                    '<textarea name="diagnosis_description" role="diagnosis_description" class="input_grad" rows="4" style="width: 400px; resize: vertical;"></textarea>' +
                    '</div>' +
                    '</div>';
            }

            this.diagnosisDescription = $(diagnosis_description);
        },

        initializeAutoSearch: function () {
            var that = this;

            var searchElem = that.mainDiagnoseElement.find('[role=principal_diagnosis]');

            searchElem.autocomplete({
                search: function (event, ui) {
                    Hades.showLoading();
                },
                source: function (request, response) {
                    $.ajax({
                        url: "/diagnosis/search_diagnosis_list_ayt",
                        dataType: "jsonp",
                        data: {
                            featureClass: "P",
                            style: "full",
                            maxRows: 12,
                            name_startsWith: request.term
                        },
                        success: function (data) {
                            Hades.hideLoading();

                            response($.map(data, function (item) {
                                return {
                                    label: "(" + item.code + ") " + item.desc,
                                    value: "(" + item.code + ") " + item.desc,
                                    code: item.code,
                                    description: item.desc
                                }
                            }));
                        },
                        error: function (xhr, status, error) {
                            Hades.showError(error, xhr.responseText, xhr, status, error);
                            Hades.hideLoading();
                        }
                    });
                },
                minLength: 2,
                select: function (event, ui) {
                    if (ui.item) {
                        that.updateMainDiagnosis(ui.item);
                    }
                },
                open: function () {
                    $(this).removeClass("ui-corner-all").addClass("ui-corner-top");
                },
                close: function () {
                    $(this).removeClass("ui-corner-top").addClass("ui-corner-all");
                }
            });
        },

        _drawSecundaryDiagnose: function () {
            var table_secundary_diagnosis = '<div>' +
                '<table role="secundary_diagnosis_ct" cellpadding="0" cellspacing="0" class="non_interactive">' +
                (this.readOnly ? '<tr role="secundary_diagnosis_header"><td><div class="detail_label" style="width: 100%; margin-bottom: 8px;">' + this.options.addSecundaryDiagnosisTranslate + '</div></td></tr>' : '') +
                '</table>' +
                '</div>' +
                '<div class="spacer"></div>';

            this.secundaryDiagnoseElement = $(table_secundary_diagnosis);
        },

        _drawMedicalActs: function () {

            if ( this.options.surgicalActCodifiedMandatory ){
                var label_medical_act_mandatory = '<label for="mandatory_surgical_acts" class="form_label form_label_mandatory">' + this.options.surgicalActsTranslate + '</label>';
                var mandatory_surgical_acts_input = '<input id="mandatory_surgical_acts" name="mandatory_surgical_acts" type="hidden" class="form_field form_field_mandatory" >';
            } else {
                var label_medical_act_mandatory = '<label for="mandatory_surgical_acts" class="form_label">' + this.options.surgicalActsTranslate + '</label>';
                var mandatory_surgical_acts_input = '<input id="mandatory_surgical_acts" name="mandatory_surgical_acts" type="hidden" class="form_field" >';
            }

            var surgical_acts = '<div class="form_elem" style="margin-top: 15px;">' +
                '<div>' +
                '<div class="form_label">' + label_medical_act_mandatory +
                '</div>' +
                '<div class="float_left">' +
                '<input type="text" value="" style=" float: left; min-width:240px; width: 400px;" class="input_grad" role="surgical_acts_input" name="surgical_acts" placeholder="' + this.options.surgicalActsTranslate + '">' +
                '<div class="float_left" style="margin-left: 4px;">' +
                '<button role="surgical-act-search-btn" type="button" class="square_btn search_square_btn search_surgical_act" tabindex="-1"></button>' +
                '<button role="surgical_act-cancel-btn" type="button" class="float_left square_btn close_square_btn cancel_surgical_act" tabindex="-1" style="display: none;" ></button>' +
                '</div>' +
                '</div>' +
                '<div class="spacer"></div>' +
                '</div>' +
                '</div>';

            var table_surgical_acts = '<div style="padding-top: 8px; padding-bottom: 15px; display: none;" role="surgical-acts-ct">' +
                '<table role="surgical_acts" cellpadding="0" cellspacing="0" class="non_interactive" style="width: 100%">' +
                '<tr>' +
                (this.readOnly ? '' : '<td style="text-align: left; width: 30px;"></td>') +
                '<td style="text-align: left; width: 160px;"><label>' + this.options.codeTranslate + '</label></td>' +
                '<td style="text-align: left; "><label>' + this.options.descriptionTranslate + '</label></td>' +
                '<td style="text-align: center; width: 100px;"><label>' + this.options.kTranslate + '</label></td>' +
                '<td style="text-align: left; width: 200px;"><label>' + this.options.valorizationTranslate + '</label></td>' +
                '<td style="text-align: left; width: 250px;"><label for="surgical_act_lateralization" class="form_label_mandatory">' + this.options.lateralityTranslate + '</label></td>' +
                '<td style="text-align: center; width: 45px;"><label title="' + this.options.vidTitleTranslate + '">' + this.options.vidTranslate + '</label></td>' +
                '<td style="text-align: center; width: 45px;"><label title="' + this.options.extTitleTranslate + '">' + this.options.extTranslate + '</label></td>' +
                '<td style="text-align: center; width: 45px;"><label title="' + this.options.incTitleTranslate + '">' + this.options.incTranslate + '</label></td>' +
                '<td style="text-align: center; width: 45px;"><label title="' + this.options.tratTitleTranslate + '">' + this.options.tratTranslate + '</label></td>' +
                '<td style="text-align: left; width: 45px; padding-left: 4px"><label title="' + this.options.percentageTranslate + '">' + this.options.percentageTranslate + '</label></td>' +
                '</tr>' +
                '</table>' +
                '</div>';

            var surgical_act_description = '';
            if (this.readOnly) {
                surgical_act_description = '<div class="detail_elem" style="min-width: 245px; padding-bottom: 0px; margin-bottom: 0px; margin-top: 8px;">' +
                    '<div class="detail_label" style="width: 100%;">' + this.options.surgicalActDescriptionTranslate + '</div>' +
                    '<div class="form_elem " style="margin-top: 8px;" role="surgical_act_description"></div>' +
                    '</div>';

            } else {
                surgical_act_description = '<div class="form_elem">' +
                    '<div class="form_label">' +
                    '<label for="surgical_act_description" class="form_label ">' + this.options.surgicalActDescriptionTranslate + '</label>' +
                    '</div>' +
                    '<div class="form_value">' +
                    '<textarea name="surgical_act_description" role="surgical_act_description" class="input_grad" rows="4" style="width: 400px; resize: vertical;"></textarea>' +
                    '</div>' +
                    '</div>';
            }

            this.medicalActSearchElem = $(surgical_acts);
            this.medicalActsMandatory = $(mandatory_surgical_acts_input);
            this.medicalActsTableElem = $(table_surgical_acts);
            this.medicalActDescriptionElem = $(surgical_act_description);
        },
        loadState: function () {
            //debug.log("loadState this",this.surgical_record);
            var params = {
                id: this.nosologicGroupId,
                surgical_record: this.surgical_record,
                surgical_screen_type: this.surgical_screen_type
            };

            this.component.hide();
            this.loading.show();

            var that = this;
            debug.log("params",params);

            $.getJSON('/surgery/get_nosologic_group_info', params)
                .done(function (data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);
                    debug.log('nosologic group - ',data);
                    that.drawFromState(data);
                    that.loading.hide();
                    that.component.show();
                })
                .fail(function (xhr, status, error) {
                    Hades.showError(error, xhr.responseText, xhr, status, error);
                });
        },
        drawFromState: function (data) {
            // main diagnose
            debug.log('drawFromState: ', data);
            if (data.group.principal_diagnosis_code) {
                var mainDiagnose = {
                    code_type_id: data.group.diagnosis_code_type_id,
                    code: data.group.principal_diagnosis_code,
                    description: data.group.principal_diagnosis_desc
                };

                this.updateMainDiagnosis(mainDiagnose);
            } else {
                this.clearPrincipalDiagnosis();
            }

            this.updateDiagnosisFreeText( data.group.diagnosis_free_text);
            // Other diagnosis
            this.secundaryDiagnosisList({diagnosis: data.diagnosis});

            // Medical acts
            this.element.find('table[role=surgical_acts] tr.surgical_act_row').remove();
            this.addMedicalActs(data.medical_acts);

            if (data.group.medical_act_free_text) {
                if (this.readOnly) {
                    this.element.find('[role=surgical_act_description]').html(data.group.medical_act_free_text);
                } else {
                    this.element.find('[role=surgical_act_description]').val(data.group.medical_act_free_text);
                }
            } else {
                if (this.readOnly) {
                    this.element.find('[role=surgical_act_description]').html('---');
                } else {
                    this.element.find('[role=surgical_act_description]').val(null);
                }
            }
        },
        searchDiagnosisModal: function () {
            const p = {
                id: this.element.attr('id')
            };

            diagnosisNS.searchDiagnosisModal(this.onDiagnosisConfirm.bind({}), p);
        },

        onDiagnosisConfirm: function (event, data, params) {
            $('#' + params.id).nosologicGroup('updateMainDiagnosis', data);
        },

        updateMainDiagnosis: function (data) {
            debug.log('updateMainDiagnosis: ', data);
            var mainDiagnosis = this.element.find('[role=principal_diagnosis]');
            var mainSearchBtn = this.element.find('[role=search_diagnosis]');
            var mainClearBtn = this.element.find('[role=clear_diagnosis]');

            var diagnose_str = '(' + data.code + ')' + ' ' + data.description;

            if (this.readOnly) {
                $(mainDiagnosis).html(diagnose_str);
            } else {
                $(mainDiagnosis).val(diagnose_str).attr('disabled', 'disabled');

            }

            $(mainClearBtn).show();
            $(mainSearchBtn).hide();

            this.mainDiagnose = {
                code: data.code,
                description: data.description
            }
        },

        updateDiagnosisFreeText: function (diagnosis_free_text) {
            var mainDiagnosisDescription = this.element.find('[role=diagnosis_description]');

            if (this.readOnly) {
                $(mainDiagnosisDescription).html(diagnosis_free_text);
            } else {
                $(mainDiagnosisDescription).val(diagnosis_free_text);
            }
        },

        clearPrincipalDiagnosis: function () {
            var mainDiagnosis = this.element.find('[role=principal_diagnosis]');
            var mainSearchBtn = this.element.find('[role=search_diagnosis]');
            var mainClearBtn = this.element.find('[role=clear_diagnosis]');

            $(mainDiagnosis).val(null);
            $(mainDiagnosis).removeAttr('disabled');

            $(mainClearBtn).hide();
            $(mainSearchBtn).show();

            this.mainDiagnose = {};
        },

        searchMultipleDiagnosisModal: function () {
            var params = {
                id: this.element.attr('id')
            };

            diagnosisNS.searchMultipleDiagnosisModal(this.onMultipleDiagnosisConfirm.bind({}), params);
        },

        onMultipleDiagnosisConfirm: function (event, data, params) {
            $('#' + params.id).nosologicGroup('secundaryDiagnosisList', data);

        },

        secundaryDiagnosisList: function (data) {
            var table = this.element.find('[role=secundary_diagnosis_ct]'), html_row, template;

            if (this.readOnly) {
                template = '<tr data-code="${DIAGNOSIS_CODE}" data-id="${INDEX}">' +
                    '<td role="secundary_diagnose_desc" style="text-align: left; border-bottom: solid 1px #DDDDDD; padding: 8px 0px;">(${DIAGNOSIS_CODE}) ${DIAGNOSIS_DESC}</td></tr>';
            } else {
                template = '<tr data-code="${DIAGNOSIS_CODE}" data-id="${INDEX}"><td style="text-align: left; width: 40px;">' +
                    '<span style="cursor: pointer;" class="ui-icon ui-icon-red ui-icon-trash remove_secundary_diagnosis_line"></span></td>' +
                    '<td role="secundary_diagnose_desc" style="text-align: left;">(${DIAGNOSIS_CODE}) ${DIAGNOSIS_DESC}</td></tr>';
            }

            $.each(data.diagnosis, function (index, row) {
                html_row = template.replace(/\$\{DIAGNOSIS_CODE\}/g, row.diagnosis_code).replace('${DIAGNOSIS_DESC}', row.diagnose_desc).replace('${INDEX}', index);

                if(table.find('tr[data-code=' + row.diagnosis_code + ']').length == 0) {
                    table.append(html_row);
                }
            });

            if (data.diagnosis.length > 0) {
                this.secundaryDiagnoseElement.css('margin-top', '8px');

                if (this.readOnly) {
                    this.secundaryDiagnoseElement.css('margin-bottom', '8px');
                }
            } else {
                if (this.readOnly) {
                    this.component.find('[role=secundary_diagnosis_header]').hide();
                    this.secundaryDiagnoseElement.css('margin-bottom', '0px');
                }
            }
        },

        removeLinesSecundaryDiagnosisTable: function (elem) {
            $(elem).closest('tr').remove();
        },

        searchSurgicalActModal: function () {
            surgeryNS.searchSurgicalActModal(function (evt, data, params) {
                $('#' + params.id).nosologicGroup('onSurgicalActConfirm', evt, data);
            }, {id: this.element.attr('id')});
        },

        onSurgicalActConfirm: function (event, data) {
            $.fancybox.close();

            //if (this.element.find('table[role=surgical_acts] tr[data-om=' + data.om_id + ']').length == 0) {
                this.addMedicalActs([data]);
            //}KHIS-2974

            $('#participants').participantSelector('onUpdateSurgicalActs', this.index);

        },
        addMedicalActs: function (acts) {

            var table = this.element.find('table[role=surgical_acts]'), row, act, combo, colRemove, colCode, colDescription, colK, colAppreciation, colLateralization, colVid, colExt, colInc, colTrat, colPercentage;

            colRemove = '<td style="text-align: left; width: 30px;"><span class="ui-icon ui-icon-red ui-icon-trash remove_surgical_act" style="cursor: pointer" ></span></td>';
            colCode = '<td role="surgical_act_code" style="text-align: left; width: 160px;"><span>${CODE}</span></td>';
            colDescription = '<td role="surgical_act_desc" style="text-align: left; "><span>${DESC}</span></td>';
            colK = '<td role="surgical_act_k" style="text-align: center; width: 100px;"><span>${K}</span></td>';
            colVid = '<td role="surgical_act_vid" style="text-align: center; width: 45px;"><input type="checkbox" ' + (this.readOnly ? 'disabled="disabled"' : '') + ' class="check_video" ${VID}></td>';
            colExt = '<td role="surgical_act_ext" style="text-align: center; width: 45px;"><input type="checkbox" ' + (this.readOnly ? 'disabled="disabled"' : '') + ' class="check_ext" ${EXT}></td>';
            colInc = '<td role="surgical_act_inc" style="text-align: center; width: 45px;"><input type="checkbox" ' + (this.readOnly ? 'disabled="disabled"' : '') + ' class="check_inc" ${INC}></td>';
            colTrat = '<td role="surgical_act_trat" style="text-align: center; width: 45px;"><input type="checkbox" ' + (this.readOnly ? 'disabled="disabled"' : '') + ' class="check_trat" ${TRAT}></td>';


            if (this.readOnly) {
                colAppreciation = '<td role="surgical_act_appreciation" style="text-align: left; width: 200px;"><span>${APPRECIATION}%</span></td>';
                colLateralization = '<td role="surgical_act_lateralization" style="text-align: left; width: 250px;"><span>${LATERALIZATION_DESC}</span></td>';
                colPercentage = '<td role="surgical_act_percentage" style="text-align: left; width: 45px;"><span>${PERCENTAGE}</span></td>';
            } else {
                colAppreciation = '<td role="surgical_act_appreciation" style="text-align: left; width: 200px;"><div class="form_value form_value_30 input-prepend"><input class="float_left" type="number" min="0" style="width: 140px;" value="${APPRECIATION}" onkeypress="return GlobalFn.validateChar(event, this)" ><span class="add-on float_left" style=" text-align: center; padding: 4px;">%</span></div></td>';
                colLateralization = '<td role="surgical_act_lateralization" style="text-align: left; width: 250px;"><label for="select_lateralization" class="form_label form_label_mandatory" style="display: none;">' + this.options.lateralityTranslate + '</label><select id="select_lateralization" name="select_lateralization" class="input_grad select_lateralization form_field_mandatory"></select></td>';
                colPercentage = '<td role="surgical_act_percentage" style="text-align: center; width: 45px;"><div class="form_value form_value_30  input-prepend"><input class="float_left" type="text" style="width: 45px;" value="${PERCENTAGE}" ></div></td>';
            }

            for (var i = 0; i < acts.length; i++) {
                act = acts[i];

                row = $('<tr class="surgical_act_row" data-om="' + act.om_id + '"data-id="' + this.surgicalActNextId + '" style="padding: 4px 8px; border-top: solid 1px #dddddd; height: 50px;" ></tr>');

                if (!this.readOnly) {
                    row.append(colRemove);
                }


                if (act.k == null) {
                   act.k = '-'
                }
                row.append(colCode.replace('${CODE}', act.code));
                row.append(colDescription.replace('${DESC}', act.desc));
                row.append(colK.replace('${K}', act.k));
                row.append(colAppreciation.replace('${APPRECIATION}', act.appreciation));
                row.append(colLateralization.replace('${LATERALIZATION_DESC}', act.lateralization_desc));
                row.append(colVid.replace('${VID}', (GlobalFn.toBoolean(act.vid) ? 'checked="checked"' : '')));
                row.append(colExt.replace('${EXT}', (GlobalFn.toBoolean(act.ext) ? 'checked="checked"' : '')));
                row.append(colInc.replace('${INC}', (GlobalFn.toBoolean(act.inc) ? 'checked="checked"' : '')));
                row.append(colTrat.replace('${TRAT}', (GlobalFn.toBoolean(act.trat) ? 'checked="checked"' : '')));
                row.append(colPercentage.replace('${PERCENTAGE}', act.percentage ));

                table.append(row);

                if (!this.readOnly) {
                    combo = row.find('select.select_lateralization');
                    //combo.chosen();

                    this.getLateralizationList(combo, {prevVal: act.lateralization_id});
                }

                this.surgicalActNextId++;

                this.medicalActsMandatory.val(act.code);
            }


            if (this.element.find('table[role=surgical_acts] tr.surgical_act_row').length == 0) {
                this.element.find('[role=surgical-acts-ct]').hide();
            } else {
                this.element.find('[role=surgical-acts-ct]').show();
            }
        },
        getLateralizationList: function (elem, options) {
            if (this.lateralizationList.length == 0) {
                let _this = this;
                $.getJSON('/surgery/get_lateralization_list')
                    .done(function (data, status, xhr) {
                        Hades.checkIfUserIsAuthorized(data, status, xhr);


                        _this.lateralizationList = data;

                        GlobalFn.updateLookupList(elem, data, null, options);
                    })
                    .fail(function (xhr, status, error) {
                        Hades.showError(error, xhr.responseText, xhr, status, error);
                    });
            } else {
                
                GlobalFn.updateLookupList(elem, this.lateralizationList, null, options);
            }


        },

        removeSurgicalActLine: function (elem) {
            debug.log('khis.nosologicGroup - removeSurgicalActLine');

            $(elem).closest('tr').remove();

            if (this.element.find('table[role=surgical_acts] tr.surgical_act_row').length == 0) {
                this.element.find('[role=surgical-acts-ct]').hide();
                this.medicalActsMandatory.val('');
            }

            $('#participants').participantSelector('onUpdateSurgicalActs');
        },

        getPrincipalDiagnose: function () {
            return this.mainDiagnose;
        },

        getDiagnoseDescription: function () {
            return this.element.find('[role=diagnosis_description]').val();
        },

        getSecundaryDiagnosis: function () {
            return this.element.find('table[role=secundary_diagnosis_ct] tr').map(function (index, row) {
                return {
                    code: $(row).data('code'), description: $(row).find('td[role=secundary_diagnose_desc]').html()
                };
            }).get();
        },

        getSurgicalActs: function () {
            return this.element.find('table[role=surgical_acts] tr.surgical_act_row').map(function (index, row) {
                debug.log('getSurgicalActs ng_index: ', $(row).closest('[role=nosologic-group-container]').data('index'));
                return {
                    om_id: $(row).data('om'),
                    code: $(row).find('td[role=surgical_act_code] span').html(),
                    description: $(row).find('td[role=surgical_act_desc] span').html(),
                    k: $(row).find('td[role=surgical_act_k] span').html(),
                    appreciation: $(row).find('td[role=surgical_act_appreciation] div input').val(),
                    lateralization: $(row).find('td[role=surgical_act_lateralization] select').val(),
                    lateralization_desc: $(row).find('td[role=surgical_act_lateralization] select option:selected').text(),
                    video: ( $(row).find('td[role=surgical_act_vid] input.check_video').is(':checked') ? true : false ),
                    ext: ( $(row).find('td[role=surgical_act_ext] input.check_ext').is(':checked') ? true : false ),
                    inc: ( $(row).find('td[role=surgical_act_inc] input.check_inc').is(':checked') ? true : false ),
                    trat: ( $(row).find('td[role=surgical_act_trat] input.check_trat').is(':checked') ? true : false),
                    percentage: $(row).find('td[role=surgical_act_percentage] input').val(),

                    ng_index: $(row).closest('[role=nosologic-group-container]').data('index')

                };
            }).get();
        },

        getSurgicalActDescription: function () {
            return this.element.find('[role=surgical_act_description]').val();
        },

        getNosologicGroup: function () {
            return {
                nosologic_group_id: this.nosologicGroupId,
                index: this.index,
                principal_diagnosis: this.getPrincipalDiagnose(),
                diagnosis_description: this.getDiagnoseDescription(),
                secundary_diagnosis: this.getSecundaryDiagnosis(),
                surgical_acts: this.getSurgicalActs(),
                surgical_act_description: this.getSurgicalActDescription()
            };
        }
    });

})();